/**
 * App\Enums\ReviewAudience — who a "Pages Ready for Review" email is for, which decides
 * the pages it lists and who may receive it.
 */
export enum ReviewAudience {
  /** Pages in internal review; exact `@brafton.com` recipients only. */
  Internal = 'internal',
  /** Pages in client review; any recipient. */
  Client = 'client',
}
